import { gql } from 'apollo-boost';

export const PREVIEW_EMAIL = gql`
    query PreviewEmail($data: PreviewEmailInput!) {
        previewEmail(data: $data)
    }
`;

